import { APIModel } from '@shared/interfaces';
import { ImportType } from '@/tax/models/import-type.enum';
import { PollingStatus } from '@/tax/models/polling-status.enum';
import { SingleImport } from '@/tax/models/single-import.model';
import { SingleImportStatus } from '@/tax/models/single-import-status.enum';

export class BulkImport implements APIModel {
    id = -1;
    firmId = -1;
    createdAt = new Date();
    type: ImportType = ImportType.TaxOnWeb;
    status: PollingStatus = PollingStatus.Init;
    imports: SingleImport[] = [];

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.firmId = data.firm_id ?? -1;
        this.type = data.type ?? ImportType.TaxOnWeb;
        this.status = data.status ?? SingleImportStatus.Init;
        this.createdAt = data.created_at ? new Date(data.created_at) : this.createdAt;
        this.imports = data.imports ? data.imports.map((importData: any) => new SingleImport().deserialize(importData)) : [];

        return this;
    }
}
